import React from 'react';
import { LocalPageTemplate } from '../components/LocalPageTemplate';
export function WebdesignUithoornPage() {
  return <LocalPageTemplate cityName="Uithoorn" region="Amstelland" introText="Professionele websites voor ondernemers in Uithoorn. Wij bouwen websites die jouw bedrijf laten groeien in deze gezellige gemeente aan de Amstel." localContext="Uithoorn is een levendige gemeente ten zuiden van Amsterdam, gelegen aan de Amstel en de Meijepolder. Met een gezellig centrum, het winkelgebied Zijdelwaard en een actief ondernemersleven biedt Uithoorn een prettig vestigingsklimaat. De gemeente trekt gezinnen en forensen dankzij de goede bereikbaarheid naar Amsterdam en Schiphol. Voor lokale ondernemers is online vindbaarheid cruciaal om zowel Uithoornse klanten als het bredere Amstelland-publiek te bereiken." nearbyLocations={[{
    name: 'Aalsmeer',
    slug: 'aalsmeer'
  }, {
    name: 'Amstelveen',
    slug: 'amstelveen'
  }, {
    name: 'Ouder-Amstel',
    slug: 'ouder-amstel'
  }, {
    name: 'Haarlemmermeer',
    slug: 'haarlemmermeer'
  }]} faqs={[{
    q: 'Wat kost een website laten maken in Uithoorn?',
    a: 'Een professionele bedrijfswebsite in Uithoorn start vanaf €1.500. De investering hangt af van je wensen, van een eenvoudige bedrijfssite tot een uitgebreide site met webshop. We geven altijd vooraf een transparante offerte.'
  }, {
    q: 'Bouwen jullie ook websites voor lokale winkels in Zijdelwaard of Amstelplein?',
    a: 'Ja, wij bouwen websites voor retailers die hun online aanwezigheid willen versterken. Van een stijlvolle etalage-website tot een volledige webshop, we zorgen dat je ook online klanten aantrekt naast je fysieke winkel.'
  }]} data-id="element-1859" />;
}